import { Component } from '@angular/core';

/**
 * Generated class for the OrComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'or',
  templateUrl: 'or.html'
})
export class OrComponent {
}



// WEBPACK FOOTER //
// ./src/components/or/or.ts